module.exports = __webpack_public_path__ + "assets/img/serve3.ecfd412a.png";